import * as React from 'react';
import { styled } from '@linaria/react';

import KbdWheel from './KbdWheel';

interface Props {
  layers: number;
}

function KeyboardControls({ layers }: Props) {
  return (
    <Wrapper>
      <KbdWheel
        layers={layers}
        value={0}
        min={-1}
        max={1}
        label="Pitch Bend"
        controlType="pitch"
      />
      <KbdWheel
        layers={layers}
        value={0.5}
        min={0}
        max={1}
        label="Mod Wheel"
        controlType="mod"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px;
  height: 100%;
`;

export default KeyboardControls;
